import { render, staticRenderFns } from "./BotView.vue?vue&type=template&id=77d2d716&scoped=true&"
import script from "./BotView.vue?vue&type=script&lang=js&"
export * from "./BotView.vue?vue&type=script&lang=js&"
import style0 from "../style/bot-view.scss?vue&type=style&index=0&id=77d2d716&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d2d716",
  null
  
)

export default component.exports